/**
 * IMPORTANMT!!!!!
 * 
 * until a better solution is found, if we need to, this file has to be copied between this and oh-requests-admin / services folders
 */


/**
 * This is the form used for Religious COVID19 vax and booster exemptions
 */
export const covidVaxNBoosterFormFields = {
    religiousBelief:{
        key:"religiousBelief",
        label: "Please identify your sincerely held religious belief, practice, or observance."
    },
    howReligiousBeliefRestricts:{
        key:"howReligiousBeliefRestricts",
        label: "Please explain how your above sincerely held religious belief governs/limits the activities you engage in in your daily life."
    },
    howReligiousBeliefPrevents:{
        key:"howReligiousBeliefPrevents",
        label: "Please explain how your above sincerely held religious belief prevents you from fulfilling this requirement."
    },
    fluExempt:{
        key:"fluExempt",
        label: "Do you currently have a religious exemption from MedStar Health’s annual mandatory influenza/flu vaccination requirement?"
    },
    sameFluExempt:{
        key:"sameFluExempt",
        label: "If yes, is the religious belief that prevented you from receiving the annual mandatory influenza/flu vaccination the same as" + 
               " the religious belief that is currently preventing you from receiving the COVID-19 vaccination?"
    },
    isAllVaxExempt:{
        key:"isAllVaxExempt",
        label:"Does your religious belief identified above prevent you from receiving other vaccines or just the COVID-19 vaccine?"
    },
    whyReligiousPrevents: {
        key:"whyReligiousPrevents",
        label: (<>If your religious belief prevents you from receiving only the COVID-19 vaccines, please explain why.
                <span className="text-muted">
                For example, if there is something about the way that the currently approved COVID-19 
                vaccines are manufactured that prevents you from receiving it, please identify what that is.
                </span></>)
    }
}

export const fluVaxFormFields = {
    religiousBeliefFlu:{
        key:"religiousBeliefFlu",
        label: "Please name your sincerely held religious belief, practice, or observance."
    },
    howReligiousBeliefRestrictsFlu:{
        key:"howReligiousBeliefRestrictsFlu",
        label: "Please explain how your above sincerely held religious belief influences the activities you engage in in your daily life."
    },
    howReligiousBeliefPreventsFlu:{
        key:"howReligiousBeliefPreventsFlu",
        label: "Please explain how your above sincerely held religious belief prevents you from fulfilling the flu vaccine requirement."
    },
    hasReligiousExemption:{
        key:"hasReligiousExemption",
        label: "Do you currently have a religious exemption from MedStar Health’s annual mandatory influenza/flu vaccination requirement?"
    }
};


export const n95FitFormFields = {
    religiousBeliefN95:{
        key:"religiousBeliefN95",
        label: "Please name your sincerely held religious belief, practice, or observance."
    },
    howReligiousBeliefRestrictsN95:{
        key:"howReligiousBeliefRestrictsN95",
        label: "Please explain how your above sincerely held religious belief influences the activities you engage in in your daily life."
    },
    howReligiousBeliefPreventsN95:{
        key:"howReligiousBeliefPreventsN95",
        label: "Please explain how your above sincerely held religious belief prevents you from fulfilling the N95 fit testing requirement."
    }
}